module.exports = __webpack_public_path__ + "static/media/A (10).f941b7ab.jpg";